<div class="container">
    <div class="section-title-wrap section-header text-center">
        <h5 class="custom-primary">Tendances</h5>
        <h2 class="title">Les Favoris de Nos Clients</h2>
        <p class="subtitle">
            Découvrez les plats préférés de nos clients ! Ces incontournables, régulièrement plébiscités, raviront vos papilles. Laissez-vous guider par leurs coups de cœur pour une expérience savoureuse
        </p>
    </div>
    <ngx-slick-carousel #slickModal="slick-carousel" [config]="settings" class="product-slider">
        <!-- Product Start -->
        <div ngxSlickItem class="product" *ngFor="let item of products">
            <a class="product-thumb" routerLink="/menu-item-v1/{{item.id}}"> <img [src]="item.img"
                    alt="{{item.name}}" /> </a>
            <div class="product-body">
                <div class="product-desc">
                    <h4> <a routerLink="/menu-item-v1/{{item.id}}">{{item.name}}</a> </h4>
                    <p>{{item.shortdesc}}</p>
                    <!-- <p class="product-price">{{item.price | number:'1.2-2'}}$</p> -->
                    <div class="favorite">
                        <i class="far fa-heart"></i>
                    </div>
                </div>
                <div class="product-controls">
                    <a routerLink="/menu-item-v1/{{item.id}}" class="order-item btn-custom btn-sm shadow-none">Commander
                        <i class="fas fa-shopping-cart"></i> </a>
                    <!-- <button type="button" class="btn-custom secondary btn-sm shadow-none"
                        (click)="open(shopmodal, item)"> Customize <i class="fas fa-plus"></i> </button> -->
                </div>
            </div>
        </div>
        <!-- Product End -->
    </ngx-slick-carousel>
    <div class="ct-arrows centered-arrows">
        <i class="slider-prev fas fa-arrow-left slick-arrow"></i>
        <i class="slider-next fas fa-arrow-right slick-arrow"></i>
    </div>
</div>
<ng-template #shopmodal let-modal>
    <button type="button" class="close-btn" (click)="modal.dismiss('Cross click')">
        <span></span>
        <span></span> 
    </button>
    <div class="modal-header modal-bg" style="background-image: url('{{modalContent.img}}')">
        
    </div>
    <div class="modal-body">
        <div class="customize-meta">
            <h4 class="customize-title">{{modalContent.name}} <span class="custom-primary">{{modalContent.price |
                    number:'1.2-2'}}$</span> </h4>
            <p>{{modalContent.shortdesc}}</p>
        </div>
        <div class="customize-variations">
            <div class="customize-size-wrapper">
                <h5>Size: </h5>
                <div class="customize-size" [ngClass]="item.state == true ? 'active' : ''" 
                    *ngFor="let item of modalContent.sizes">
                    {{item.size}}"
                </div>
            </div> 
            <div class="row">
                <!-- Variation Start -->
                <div class="col-lg-4 col-12" *ngFor="let item of modalContent.attributes | slice:0:3">
                    <div class="customize-variation-wrapper">
                        <i class="{{item.icon}}"></i>
                        <h5>{{item.name}}</h5>
                        <div class="customize-variation-item" *ngFor="let add of item.items">
                            <div class="custom-control custom-{{item.type}}">
                                <input type="{{item.type}}" id="{{add.title + 1}}" name="{{item.name}}" class="custom-control-input">
                                <label class="custom-control-label" for="{{add.title + 1}}">{{add.title}}</label>
                            </div>
                            <span>+{{add.addprice | number:'1.2-2'}}$</span>
                        </div>
                    </div>
                </div>
                <!-- Variation End -->
            </div>
        </div>
        <div class="customize-controls">
            <div class="qty">
                <span class="qty-subtract"><i class="fas fa-minus"></i></span>
                <input type="text" name="qty" value="1">
                <span class="qty-add"><i class="fas fa-plus"></i></span>
            </div>
            <div class="customize-total">
                <h5>Total Price: <span class="final-price custom-primary">{{modalContent.price | number:'1.2-2'}} <span>$</span> </span> </h5>
            </div>
        </div>
        <button type="button" class="btn-custom btn-block">Commander maintenant</button>
    </div>
</ng-template>